export enum RoomRevenuModel {
    ONLY_ROOM_REVENUE = "only_room_revenue",
    ROOM_REVENUE_WITH_PACKAGE_ITEMS = "room_revenue_with_package_items"
}